
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"36.269","cy":"34.784","fill":"#D0EFEC","rx":"1.5","ry":"2","transform":"rotate(15 36.269 34.784)"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"2.017","d":"M35.266 34.67c.266.07.37.562.226 1.095-.143.533-.478.907-.743.836-.266-.071-.366-.561-.223-1.095s.474-.908.74-.837Z"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M41.913 25.203a1.18 1.18 0 0 1-1.161.984H16.459a.536.536 0 0 1-.532-.605l.816-6.31H42.9z"}}),_c('ellipse',{attrs:{"cx":"14.916","cy":"34.832","fill":"#D0EFEC","rx":"1.5","ry":"2","transform":"rotate(15 14.916 34.832)"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"2.017","d":"M13.914 34.717c.265.071.369.562.226 1.096-.143.533-.478.907-.744.836s-.365-.561-.222-1.095.474-.908.74-.837Z"}}),_c('path',{attrs:{"fill":"#D0EFEC","d":"M7.672 17.386h5.815v1.179H7.672zM7.515 23.202h5.815v1.179H7.515zM5 20.294h8.33v1.179H5z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"round","d":"M15.906 14.263 13.051 10H7.67M16 28l-.863 3.845h20.43"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linecap":"square","stroke-linejoin":"round","d":"M41 14.05 15.914 14l-1.915 13.95 24.583.05z"}})])
          )
        }
      }
    